module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hress5u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHress5uIndex,
      "searchBoxAlias": "approve",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.postHress5uSendApprove
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "labels": _vm.labels[_vm.dash.nowLang],
      "detail": _vm.detail,
      "tab2Table": _vm.columns[_vm.dash.nowLang].detailTab2,
      "columnsDetailTab2Popup2Tab2": _vm.columns[_vm.dash.nowLang].detailTab2Popup2Tab2,
      "columnsDetailTab2Popup2Tab3": _vm.columns[_vm.dash.nowLang].detailTab2Popup2Tab3,
      "columnsDetailTab2Popup2Tab4": _vm.columns[_vm.dash.nowLang].detailTab2Popup2Tab4,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "popup1DetailTab2": _vm.popup1DetailTab2,
      "popup2DetailTab2": _vm.popup2DetailTab2,
      "receivedHress5uDetailTab2Popup1": _vm.receivedHress5uDetailTab2Popup1,
      "receivedHress5uDetailTab2Popup2": _vm.receivedHress5uDetailTab2Popup2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c73590bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress5u/component.vue
// module id = 3976
// module chunks = 1